const tabletrans = {
  notEntered: {
    english: "not entered",
    persian: "وارد نشده",
  },
  sendPop: {
    english: "Popups",
    persian: "پاپ آپ",
  },
  newCu: {
    english: "New Customers",
    persian: "مشتریان جدید",
  },
  message: {
    english: "Message",
    persian: "متن پیام",
  },
  discounts: {
    english: "Discounts",
    persian: "تخفیفات",
  },
  id: {
    english: "ID",
    persian: "شماره",
  },
  galleryimage: {
    english: "Gallery Image",
    persian: "عکس گالری",
  },
  credit: {
    english: "Credit",
    persian: "اعتبار",
  },
  customer: {
    english: "Customer",
    persian: "مشتری",
  },
  visitor: {
    english: "Visitor",
    persian: "ویزیتور",
  },
  analyze: {
    english: "Sale Analyze",
    persian: "آنالیز فروش",
  },
  classes: {
    english: "Classes",
    persian: "کلاس ها",
  },
  productTitle: {
    english: "Product Title",
    persian: "عنوان محصول",
  },

  activeText: {
    english: "Active",
    persian: "فعال",
  },
  deactiveText: {
    english: "Deactive",
    persian: "غیر فعال",
  },
  delete: {
    english: "delete",
    persian: "حذف",
  },
  edit: {
    english: "Edit",
    persian: "ویرایش",
  },

  dkmehrDashboard: {
    english: "DKMehr Dashboard",
    persian: "داشبورد داده کاوان",
  },
  name: {
    english: "Name",
    persian: "نام",
  },
  profile: {
    english: "Profile",
    persian: "پروفایل",
  },
  phoneNumber: {
    english: "Phone Number",
    persian: "شماره تماس",
  },
  company: {
    english: "Company",
    persian: "شرکت",
  },
  role: {
    english: "Role",
    persian: "نقش",
  },
  date: {
    english: "Date",
    persian: "تاریخ",
  },
  customers: {
    english: "Customers",
    persian: "مشتریان",
  },
  brand: {
    english: "Brand",
    persian: "برند",
  },
  transport: {
    english: "Transport",
    persian: "نحوه ارسال",
  },
  transportationStatus: {
    english: "Transportation Status",
    persian: "وضعیت تحویل",
  },
  order: {
    english: "Order",
    persian: "سفارش",
  },
  orderReg: {
    english: "Order Reg",
    persian: "ثبت سفارش",
  },
  orderNumber: {
    english: "Order Number",
    persian: "شماره سفارش",
  },
  mobileOrName: {
    english: "Mobile or Name",
    persian: "نام/تلفن",
  },
  item: {
    english: "Item",
    persian: "کالا",
  },
  countanbar: {
    english: "Count Anbar",
    persian: "موجودی",
  },
  status: {
    english: "Status",
    persian: "وضعیت",
  },
  document: {
    english: "Document",
    persian: "مستندات",
  },
  upload: {
    english: "Upload",
    persian: "آپلود",
  },
  addDoc: {
    english: "add Document",
    persian: "افزودن مستندات",
  },
  payStatus: {
    english: "Payment status",
    persian: "وضعیت پرداخت",
  },
  action: {
    english: "Action",
    persian: "عملیات",
  },
  price: {
    english: "Price",
    persian: "قیمت",
  },
  taxPrice: {
    english: "Tax Price",
    persian: "قیمت با مالیات",
  },
  details: {
    english: "Details",
    persian: "جزئیات",
  },
  print: {
    english: "Print",
    persian: "چاپ",
  },
  totalWeight: {
    english: "Total Weight",
    persian: "وزن خریداری شده",
  },
  addNew: {
    english: "Add New",
    persian: "افزودن",
  },
  service: {
    english: "Service",
    persian: "خدمات",
  },
  products: {
    english: "Products",
    persian: "محصولات",
  },
  edit: {
    english: "Edit",
    persian: "ویرایش",
  },
  subTotal: {
    english: "SubTotal",
    persian: "جمع",
  },
  shipping: {
    english: "Shipping",
    persian: "حمل و نقل",
  },
  discount: {
    english: "Discount",
    persian: "تخفیف",
  },
  taxes: {
    english: "Taxes",
    persian: "مالیات",
  },
  total: {
    english: "Total",
    persian: "جمع کل",
  },

  /*Filters */
  selectDate: {
    english: "Select Date",
    persian: "انتخاب تاریخ",
  },
  search: {
    english: "Search...",
    persian: "جستجو",
  },
  customerInfo: {
    english: "Customer Info",
    persian: "اطلاعات مشتری",
  },
  history: {
    english: "History",
    persian: "سابقه",
  },
  coridor: {
    english: "Coridor",
    persian: "کریدور",
  },
  lensSize: {
    english: "Lens Size",
    persian: "سایز لنز",
  },
  rowsPerPage: {
    english: "Rows per page: ",
    persian: "تعداد در صفحه: ",
  },
  of: {
    english: " Of ",
    persian: "از",
  },

  account: {
    english: "Account",
    persian: "پروفایل کاربری",
  },
  general: {
    english: "General",
    persian: "عمومی",
  },
  profile: {
    english: "Profile",
    persian: "کاربران",
  },
  supplementary: {
    english: "ُSupplementary",
    persian: "تکمیلی",
  },
  billing: {
    english: "Billing",
    persian: "پرداخت",
  },
  notification: {
    english: "Notification",
    persian: "هشدارها",
  },
  link: {
    english: "Link",
    persian: "لینک",
  },
  socialLink: {
    english: "Social Links",
    persian: "شبکه های اجتماعی",
  },
  security: {
    english: "Security",
    persian: "امنیت",
  },

  kind: {
    english: "Kind",
    persian: "نوع",
  },
  title: {
    english: "Title",
    persian: "عنوان",
  },
  code: {
    english: "Code",
    persian: "کد",
  },

  /*Products*/
  details: {
    english: "Details",
    persian: "جزئیات",
  },
  titleShort: {
    english: "Title, short description, image...",
    persian: "تیتر، توضیحات و تصاویر",
  },
  createProduct: {
    english: "Create a new product",
    persian: "افزدون محصول جدید",
  },
  productName: {
    english: "Product Name",
    persian: "نام محصول",
  },
  productenName: {
    english: "Product English",
    persian: "نام انگلیسی محصول",
  },
  productUrl: {
    english: "Product Url",
    persian: "آدرس محصول",
  },
  metaTitle: {
    english: "Meta Title",
    persian: "تیتر متا محصول",
  },
  productMeta: {
    english: "Product Meta Data",
    persian: "اطلاعات متا محصول",
  },
  productSubDescription: {
    english: "Sub Description",
    persian: "توضیحات مختصر",
  },
  images: {
    english: "Product Images",
    persian: "تصاویر محصول",
  },
  attributes: {
    english: "Additional functions and attributes...",
    persian: "خصوصیات اضافی",
  },

  propertie: {
    english: "Properties",
    persian: "خصوصیات",
  },
  pricing: {
    english: "Pricing",
    persian: "قیمت",
  },
  pricingRelative: {
    english: "Price related inputs",
    persian: "قیمت مرتبط",
  },
  productCode: {
    english: "Product Code",
    persian: "کد محصول",
  },
  productSku: {
    english: "Product SKU",
    persian: "شناسه محصول",
  },
  category: {
    english: "Category",
    persian: "دسته بندی",
  },
  quantity: {
    english: "Quantity",
    persian: "تعداد",
  },
  regularPrice: {
    english: "Regular Price",
    persian: "قیمت عادی",
  },

  /*Brands*/
  brands: {
    english: "Brands",
    persian: "برندها",
  },
  gallery: {
    english: "Gallery",
    persian: "گالری",
  },
  addgallery: {
    english: "add Gallery",
    persian: "افزدون یا ویرایش گالری",
  },
  addBrand: {
    english: "Add/Edit Brand",
    persian: "افزدون یا ویرایش برند",
  },
  addCategory: {
    english: "Add/Edit Category",
    persian: "افزدون یا ویرایش دسته بندی",
  },
  description: {
    english: "Description",
    persian: "توضیحات",
  },
  fullDescription: {
    english: "Full Description",
    persian: "توضیحات کامل",
  },
  brandName: {
    english: "Brand Name",
    persian: "نام برند",
  },
  update: {
    english: "Update",
    persian: "بروزرسانی",
  },

  brandCode: {
    english: "Brand Code",
    persian: "کد برند",
  },

  /*Brands*/
  brands: {
    english: "Brands",
    persian: "برندها",
  },
  addBrand: {
    english: "Add/Edit Brand",
    persian: "افزودن یا ویرایش برند",
  },
  policies: {
    english: "Policies",
    persian: "سیاست های فروش",
  },
  addPolicy: {
    english: "Add/Edit Policy",
    persian: "افزودن یا ویرایش سیاست فروش",
  },
  addCategory: {
    english: "Add/Edit Category",
    persian: "افزودن یا ویرایش دسته بندی",
  },
  addClass: {
    english: "Add/Edit Class",
    persian: "افزودن یا ویرایش کلاس ها",
  },
  description: {
    english: "Description",
    persian: "توضیحات",
  },
  classes: {
    english: "Classes",
    persian: "کلاس مشتری",
  },
  sendSms: {
    english: "Send SMS",
    persian: "ارسال پیامک",
  },
  classManage: {
    english: "Class Manage",
    persian: "مدیریت کلاس",
  },
  fullDescription: {
    english: "Full Description",
    persian: "توضیحات کامل",
  },
  policyCode: {
    english: "Policy Code",
    persian: "کد سیاست",
  },
};
export default tabletrans;
